document.addEventListener('alpine:init', () => {
  Alpine.data('ThemeModule_ModalCart', ({ openOnAddToCart }) => {
    return {
      init() {
        if (openOnAddToCart === true) {
          document.addEventListener(
            'submit',
            (event) => {
              const form = event.target;
              if (!form || form.tagName !== 'FORM') return;
              const action = form.getAttribute('action') || '';
              if (!/\/cart\/add/i.test(action)) return;
              Alpine.store('cart_count').setPending(true);
            },
            true
          );
          document.body.addEventListener(
            'shapes:modalcart:afteradditem',
            () => {
              Alpine.store('modals').open('cart');
            }
          );
        }

        Alpine.store('modals').register('cart', 'rightDrawer');
      },
    };
  });
});
